import Vue from 'vue'
import app from './App.vue'
import { post, get, getParams, loadCss, loadScript, isapp, apiUrl, site, isWeixin, openAppOrDownApp, jieliuhanshu} from './http/api'
// import moment from 'moment';
// import 'moment/locale/zh-cn';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Vant from 'vant';
import VideoPlayer from 'vue-video-player'
import { Slider, Icon } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Vant);
Vue.use(VideoPlayer)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.prototype.post = post
Vue.prototype.get = get
Vue.prototype.getParams = getParams
Vue.prototype.loadScript = loadScript
Vue.prototype.loadCss = loadCss
Vue.prototype.isapp = isapp
Vue.prototype.apiUrl = apiUrl
Vue.prototype.site = site
Vue.prototype.isWeixin = isWeixin
Vue.prototype.openAppOrDownApp = openAppOrDownApp
Vue.prototype.jieliuhanshu = jieliuhanshu

Vue.config.productionTip = false

// moment.locale('zh-cn');
// Vue.prototype.moment = moment;


new Vue({
  render: h => h(app),
}).$mount('#app')
